import React, { useState } from 'react';
import { FiLock, FiMail } from 'react-icons/fi';
import toast from 'react-hot-toast';
import { AuthButton } from '../common/AuthButton';
import TextInput from './TextInput';
import { useAuthStore } from '../../context/useAuthStore'; // Make sure this path is correct

interface ForgotPasswordFormProps {
  onSuccess: (email: string) => void;
}

export const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({ onSuccess }) => {
  const [form, setForm] = useState({ emailId: '' });
  const [errors, setErrors] = useState({ emailId: false });

  const { forgotPassword, isLoading } = useAuthStore();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));

    if (errors.emailId && value.trim() !== '') {
      setErrors({ emailId: false });
    }
  };

  const validateForm = () => {
    const isEmailEmpty = !form.emailId.trim();
    setErrors({ emailId: isEmailEmpty });
    return isEmailEmpty;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (validateForm()) {
      toast.error('Please enter a valid email.');
      return;
    }

    try {
      await forgotPassword(form.emailId);
      toast.success('OTP sent successfully!');
      onSuccess(form.emailId);
    } catch (error: unknown) {
      if (error instanceof Error) {
        toast.error(error.message || 'Failed to send OTP.');
      } else {
        toast.error('Failed to send OTP.');
      }
    }
  };

  const isFormValid = form.emailId.trim() !== '' && !errors.emailId;

  return (
    <form onSubmit={handleSubmit}>
      <TextInput
        id="emailId"
        name="emailId"
        label="Email Address"
        type="email"
        value={form.emailId}
        onChange={handleChange}
        placeholder="Enter your email address"
        required
        error={errors.emailId}
        icon={FiMail}
      />
      <AuthButton
        title="Reset Password"
        loadingTitle="Please wait..."
        icon={FiLock}
        loading={isLoading}
        disabled={!isFormValid}
      />
    </form>
  );
};
